import React, { useState } from 'react';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import SaveIcon from '@mui/icons-material/Save';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import AutoComplete from '@mui/material/Autocomplete';
import operationsHelpers from '../../helpers/operations';

const warehouse_options = [
    { value: "PA", name: "PA"},
];

function InsertWorker(props) {

    const [name, setName] = useState("");
    const [warehouse, setWarehouse] = useState("");
    const [timecardNum, setTimecardNum] = useState("");
    const [payrollNum, setPayrollNum] = useState("");
    const [photo, setPhoto] = useState("");

    const handleChange = (event) => {
        let func = `set${event.target.name[0].toUpperCase() + event.target.name.substring(1)}`;
        eval(func)(event.target.value);
    };

    const requiredFields = [
        { field: 'worker_name', message: 'Name is required.'},
        { field: 'warehouse', message: 'Warehouse is required.'},
        { field: 'timecard_num', message: 'Timecard Number is required.'},
    ];

    const checkValidity = (workerInfo) => {
        let errorMessages = [];

        for (const { field, message } of requiredFields) {
            if (!workerInfo[field]) {
                errorMessages.push(message);
            }
        }

        if (errorMessages.length > 0) {
            const error_message = errorMessages.join('\n');
            props.toast.error(error_message);
            return false;
        }
        return true;
    };

    const insertWorker = async () => {
        props.setLoading(true);
        const params = {
            worker_name: name ? name : null,
            warehouse: warehouse ? warehouse : null,
            timecard_num: timecardNum ? timecardNum : null,
            payroll_num: payrollNum ? payrollNum : null,
        };

        console.log(params);

        if (!checkValidity(params)) {
            props.setLoading(false);
            return;
        };

        try {
            const res = await operationsHelpers.insertWorker(params, props.company, props.token);
            if (res.success) {
                props.toast.success('Saved Worker!');
                window.location.reload();
                setName('');
                setWarehouse('');
                setTimecardNum('');
                setPayrollNum('');
            } else {
                props.toast.error(res.message);
            };
        } catch(err) {
            props.toast.error('Failed to save worker!');
        } finally {
            props.setLoading(false);
        };
    };

    return (
        <Dialog open = {props.open} onClose = {() => props.handleClose()} fullWidth = {true} maxWidth = {'md'}>
            <Box sx = {{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
                <DialogContent>
                    <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{ display: 'flex', flexDirection: 'column' }}>
                        <DialogTitle>
                            Insert Worker Information
                        </DialogTitle>
                        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{ display: 'flex', flexDirection: props.isMobile ? 'column' : 'row', mb: '10px' }}>
                            <TextField 
                                name = 'name'
                                label = 'Name'
                                onChange = {handleChange}
                                value = {name}
                                sx = {{ width: '25%', mr: '0.6%' }}
                                required
                            />
                            <FormControl sx = {{ width: '25%', mr: '0.6%' }}>
                                <AutoComplete
                                    value = {warehouse}
                                    key = {warehouse}
                                    onChange = {(event, newValue) => {
                                        setWarehouse(newValue ? newValue.value : null);
                                    }}
                                    id = "warehouse"
                                    options = {warehouse_options}
                                    getOptionLabel = {(option) => {
                                        if (!option.name) {
                                            return option;
                                        }
                                        return option.name;
                                    }}
                                    renderOption = {(props, option) => {
                                        let name = option.name;
                                        if (!name) {
                                            return option;
                                        }
                                        return (
                                            <li {...props}>
                                                {name}
                                            </li>
                                        );
                                    }}
                                    freeSolo
                                    forcePopupIcon = {true}
                                    renderInput = {(params) => (
                                        <TextField {...params} label = "Warehouse *" />
                                    )}
                                    required
                                />
                            </FormControl>
                            <TextField 
                                name = 'timecardNum'
                                label = 'Timecard Number'
                                onChange = {handleChange}
                                value = {timecardNum}
                                sx = {{ width: '25%', mr: '0.6%' }}
                                required
                            />
                            <TextField 
                                name = 'payrollNum'
                                label = 'Payroll Number'
                                onChange = {handleChange}
                                value = {payrollNum}
                                sx = {{ width: '25%', mr: '0.6%' }}
                            />
                        </Box>
                        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{ flexDirection: 'row' }}>
                            <DialogActions>
                                <Button 
                                    variant = "contained" 
                                    onClick = {() => insertWorker()} 
                                    disabled = {props.isLoading} 
                                    color = "success" 
                                    endIcon = {<SaveIcon />}
                                >
                                    Save
                                </Button>
                            </DialogActions>
                        </Box>
                    </Box>             
                </DialogContent>

            </Box>
        </Dialog>
    );
};

export default InsertWorker;